import { useEffect, useState } from "react";
import { getLoginCookieAndSession } from "../utils";
import { getStripeConnectAccountStatus } from "../pages/Seller/seller-setup-api";
import { StripeAccountStatusCode } from "../pages/Seller/seller-setup-types";

// Fetches the current logged-in user's Stripe connected-account status.
// Used to decide whether "sell" CTAs should route to /sell (approved) or /presell (not yet approved).
export const useStripeAccountStatus = () => {
  const [status, setStatus] = useState<StripeAccountStatusCode | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const profileId = getLoginCookieAndSession();
    if (!profileId) {
      setStatus(null);
      setLoading(false);
      return;
    }
    let cancelled = false;
    setLoading(true);
    getStripeConnectAccountStatus(profileId)
      .then((result) => {
        if (!cancelled) setStatus(result?.status ?? "PENDING");
      })
      .catch(() => {
        if (!cancelled) setStatus("PENDING");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const isApproved = status === "ACTIVE";
  const sellRoute = isApproved ? "/sell" : "/presell";

  return { status, loading, isApproved, sellRoute };
};
